import React from "react"
import styled from "styled-components"
import Strings from "../assets/strings";
import Fonts from "../assets/fonts";
import Colors from "../assets/colors";
import holdingLogo from "../assets/images/logo-holding.png"
import holdingImg from "../assets/images/404-image.jpg"

const NotFoundWrapper = styled.div`
  
`
const NotFoundContainer = styled.div`
  height: 100vh; 
  display: flex;
  justify-content: center;
  align-content: center;
  
  .container {
    margin: 25px auto;
    max-width: 1280px;
    padding: 0.5rem 0;
  }

  /* Small devices (portrait tablets and large phones, 600px and up) */
  @media only screen and (max-width: 767px) {
    .container {
      padding: 0 30px;
      max-width: 100%;
    }    
  }

  /* Medium devices (landscape tablets, 768px and up) */
  @media only screen and (min-width: 768px) and (max-width: 991px) {
    .container {
      padding: 0 30px;
      max-width: 720px;
    }
  }

  /* Large devices (laptops/desktops, 992px and up) */
  @media only screen and (min-width: 992px) and (max-width: 1279px) {
    .container {
      padding: 0 30px;
      max-width: 960px;
    }
  }

  /* Extra large devices (large laptops and desktops, 1280px and up) */
  @media only screen and (min-width: 1280px) {
    .container {
      padding: 0 30px;
      max-width: 1140px;
    }
  }
`

const InnerNotFoundContainer = styled.div`
  display: grid;
  align-self: center;
  grid-template-columns: 50fr 1fr 50fr;
  max-height: 500px;  
  
  @media only screen and (max-width: 767px) {
    grid-template-columns: 1fr;
    margin-top: 200px;
  }
`

const NotFoundTitle = styled.h1`
  color: var(--main-color-text);
  margin-bottom: 0;
  text-transform: uppercase;
  font-size: 2em;
  font-family: ${Fonts.BRANDON_BOLD};
`

const CenterDiv = styled.div`
  align-self: center;
  justify-self: ${props => props.position};
  width: auto; 
  
  &.padding-right {
    padding-right: 80px;
  }
  
  @media only screen and (max-width: 767px) {
   &.no-mobile {
      display: none !important;
    }
    &.padding-right {
    padding-right: 0;
  }
  }
`

const Line = styled.div`
  width: 1px;
  height: 350px;
  background-color: ${Colors.DARK_GRAY};
  @media only screen and (max-width: 767px) {
    &.no-mobile {
      display: none !important;
    }
  }
`

const ImageCoverNotFound = styled.div`
    position: absolute;
    top: 0;
    width: 100vw;
    height: 200px;
    background-size:cover ;
    display: none;
    background-image: url(${holdingImg});


    @media only screen and (max-width: 767px) {
            display: block;
    }

`


const NotFoundPage = () => {

    return (
        <NotFoundWrapper>
            <NotFoundContainer>
                <ImageCoverNotFound/>
                <InnerNotFoundContainer className={"container"}>
                    <CenterDiv position={"left"} className={"padding-right"}>
                        <NotFoundTitle>{Strings.NOT_FOUND}</NotFoundTitle>
                        <p style={{lineHeight:"24px"}} dangerouslySetInnerHTML={{__html: Strings.NOT_FOUND_DESC}}/>
                    </CenterDiv>
                    <Line className={"no-mobile"}/>
                    <CenterDiv position={"right"} className={"no-mobile"}>
                        <img src={holdingLogo} alt={"holding logo"} width={300}/>
                    </CenterDiv>
                </InnerNotFoundContainer>
            </NotFoundContainer>
        </NotFoundWrapper>
    )

}

export default NotFoundPage
